module.exports = __webpack_public_path__ + "static/media/keenan-constance-lAjPSof6X_o-unsplash.daaefb1d.jpg";